import { Skeleton } from '@mui/material'
import { FullWidthBar } from 'components/core-v2/atoms'

import { useGetByTenantAccountQuery } from '@/api'
import { CURRENCY, TENANT } from '@/const'
import { formatCurrencyFull } from '@/utilities/currency'
import { plural } from '@/utilities/plural'

import { useFilteredAccounts } from '../../utils/useFilteredAccounts'
import classes from '../notes-found-bar/index.module.scss'

export const TradesFoundBar = () => {
  const { data, isLoading } = useGetByTenantAccountQuery({
    tenant: TENANT
  })

  const filteredAccounts = useFilteredAccounts()

  if (isLoading) {
    return (
      <FullWidthBar
        className={classes.root}
        shouldPadXAxis={false}
        showBottomBorder={false}
        size="large"
      >
        <Skeleton height="16px" variant="rectangular" width="400px" />
      </FullWidthBar>
    )
  }

  const value = filteredAccounts.reduce((total, account) => {
    if (account.notionalCurrency === CURRENCY) return total + account.accountValue

    const rate = data.fxRates.find(fxRate => fxRate.currencyCounter === account.notionalCurrency)

    return total + account.accountValue * (1 / rate.spotRate)
  }, 0)

  return (
    <FullWidthBar
      className={classes.root}
      shouldPadXAxis={false}
      showBottomBorder={false}
      size="large"
    >
      <span className={classes.showing}>
        <strong>{filteredAccounts.length}</strong> {plural('trade', filteredAccounts.length)} found
      </span>
      <span className={classes.total}>
        <strong>{formatCurrencyFull(value, CURRENCY)}</strong> value of filtered trades
      </span>
    </FullWidthBar>
  )
}
